@for (s of sizes; track s) {
  <div class="{{ s.css + ' ' + (prefix + s.id) }}"></div>
}
